import { AccountData } from '../../../api';

export type StripeRenderProps = {
  stripeAccountId?: string;
  stripe_integration_publishable_key?: string;
};

export const stripePublishableKey = (isTestMode?: boolean): string | undefined =>
  isTestMode
    ? import.meta.env.VITE_REACT_APP_TEST_STRIPE_PUBLISHABLE_KEY
    : import.meta.env.VITE_REACT_APP_STRIPE_PUBLISHABLE_KEY;

// The key follows the account's Stripe mode. Used where the payment form comes from an order or a pass.
export const useStripeRenderProps = (account?: AccountData): StripeRenderProps => ({
  stripeAccountId: account?.stripe_connect?.stripe_account_id,
  stripe_integration_publishable_key: account?.stripe_connect
    ? stripePublishableKey(account.stripe_connect.is_stripe_test_account)
    : undefined,
});

// Payment links are created in either mode, so the key follows the Checkout Session id inside the link.
export const useStripeLinkRenderProps = (account?: AccountData, paymentLink?: string): StripeRenderProps => {
  const stripeAccountId = account?.stripe_connect?.stripe_account_id;
  return {
    stripeAccountId,
    stripe_integration_publishable_key: stripeAccountId
      ? stripePublishableKey(paymentLink?.includes('cs_test'))
      : undefined,
  };
};
